import routerOptions0 from "/vercel/path0/node_modules/.pnpm/nuxt@3.17.6_@capacitor+preferences@7.0.4_@capacitor+core@7.6.5__@parcel+watcher@2.5.6_@_794e6fe582a4bee9a5b6e343880556a7/node_modules/nuxt/dist/pages/runtime/router.options.js";
const configRouterOptions = {
  hashMode: false,
  scrollBehaviorType: "auto"
}
export const hashMode = false
export default {
...configRouterOptions,
...routerOptions0,
}